
    /**
     * @author tribes agency
     * @description component created by Tribes
     * ============================================================================================
     */
    export default {
        name: "TribesSiteFooter",
        props: {
            button: {
                default: () => ({
                    title: 'Get Started', href: 'get-started'
                }),
                type: Object
            },
            bottomMenu: {
                default: () => ([
                    {title: 'Privacy policy', href: '/privacy-policy'},
                    {title: 'Terms & Conditions', href: '/terms-and-conditions'},
                    // {title: 'Terms & Conditions USA', href: '/terms-and-conditions-us'},
                    // {title: 'Terms & Conditions Buyer USA', href: '/terms-and-conditions-buyer-us'},
                ]),
                type: Array
            },
            socials: {
                default: () => ({
                    facebook: 'https://www.facebook.com/TSASondemand',
                    instagram: 'https://www.instagram.com/tsasondemand/',
                    twitter: 'https://twitter.com/tshirtandsons',
                }),
                type: Object
            },
            title: {
                default: "We make it personal",
                type: String
            },
            topMenu: {
                default: () => ([
                    {
                        title: 'About',
                        subItems: [
                            {title: 'What is Print on demand?', href: '/about'},
                            {title: 'Promotional or Shop', href: '/about'},
                        ]
                    },
                    {
                        title: 'Make it personal',
                        subItems: [
                            {title: 'Our Products', href: '/our-products'},
                            {title: 'Get Started', href: '/get-started'},
                        ]
                    },
                    {
                        title: 'Our mission',
                        subItems: [
                            {title: 'Quality', href: '/about'},
                            {title: 'Sustainability', href: '/about'},
                        ]
                    },
                    {
                        title: 'Help',
                        subItems: [
                            {title: 'Shipping & Delivery',  href: '/about'},
                            {title: 'Support', href: 'mailto:udesignme@tshirtandsons.com'},
                            {title: 'Contact', href: 'mailto:udesignmesupport@tshirtandsons.com'},
                        ]
                    },
                ]),
                type: Array
            },
        },
        data() {
            return {
                date: new Date(),
                menuShowIndex: []
            }
        },
        methods: {
            changeActiveMenu: function (index) {
                if (this.menuShowIndex.includes(index)) {
                    this.menuShowIndex.pop(index)
                } else {
                    this.menuShowIndex.push(index)
                }
            }
        }
    }
